(function ($, window, Drupal, once) {

    'use strict';

    jQuery(document).ready(function($){
      if ($('fieldset[data-drupal-selector="edit-tid"]').length > 0) {
        $('fieldset[data-drupal-selector="edit-pid"] .form-radio').first().prop('checked','true');
        $('fieldset[data-drupal-selector="edit-tid"] .form-radio').first().prop('checked','true');
        $('select[data-drupal-selector="edit-tid-sel"] option').first().prop('selected','true');
      }
      Drupal.theme.ajaxProgressIndicatorFullscreen = function () {
        return "<div class=\"page-fade-back\"><div class=\"ajax-progress ajax-progress-fullscreen ajax-progress-new\">"+
        "<mat-spinner role=\"progressbar\" mode=\"indeterminate\" tabindex=\"-1\" class=\"mat-spinner mat-progress-spinner mat-primary mat-progress-spinner-indeterminate-animation\" style=\"width: 100px; height: 100px;\">"+
        "<svg preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\" aria-hidden=\"true\" style=\"width: 100px; height: 100px;\" viewBox=\"0 0 100 100\">"+
        "<circle cx=\"50%\" cy=\"50%\" style=\"animation-name: mat-progress-spinner-stroke-rotate-100; stroke-dasharray: 282.743px; stroke-width: 10%;\" r=\"45\"></circle></svg></mat-spinner></div></div>";
      };
      Drupal.theme.ajaxProgressThrobber = function () {
        return "<div class=\"ajax-progress ajax-progress-inline ajax-progress-new\">"+
        "<mat-spinner role=\"progressbar\" mode=\"indeterminate\" tabindex=\"-1\" class=\"mat-spinner mat-progress-spinner mat-primary mat-progress-spinner-indeterminate-animation\" style=\"width: 32px; height: 32px;\">"+
        "<svg preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\" aria-hidden=\"true\" style=\"width: 32px; height: 32px;\" viewBox=\"0 0 100 100\">"+
        "<circle cx=\"50%\" cy=\"50%\" style=\"animation-name: mat-progress-spinner-stroke-rotate-100; stroke-dasharray: 282.743px; stroke-width: 10%;\" r=\"45\"></circle></svg></mat-spinner></div>";
      };
    });

    Drupal.behaviors.faqpage = {
      attach: function (context, settings) {
        $('select[name="tid-sel"]').attr('name','tid');

        //$('#views-exposed-form-faq-page-1', context).once('mdtFaqPage').each(function () {
        once('mdtFaqPage',"#views-exposed-form-faq-page-1",context).forEach(function (value,i) {
          let checkPidRadio = $('#edit-pid .form-radio:checked').attr('id'); 
          $('fieldset[data-drupal-selector="edit-pid"]').on('click', '.form-radio', function () {                     
              if ($(this).attr('id') != checkPidRadio) {
                  $('#edit-tid .form-radio').prop('disabled',true);
              }    
          });
          $('fieldset[data-drupal-selector="edit-tid"]').on('click', '.form-radio', function () { 
            $('select[data-drupal-selector="edit-tid-sel"]').val($(this).val());
          });   
        });

        $(document).ajaxComplete(function (event, xhr, settings) {
          if (settings.data && settings.data.indexOf("view_name=faq") != -1) {                        
            let checkPidRadio = $('#edit-pid .form-radio:checked').attr('id');  
            $('fieldset[data-drupal-selector="edit-pid"]').on('click', '.form-radio', function () {                     
                if ($(this).attr('id') != checkPidRadio) {
                    $('#edit-tid .form-radio').prop('disabled',true);
                }    
            });
            $('fieldset[data-drupal-selector="edit-tid"]').on('click', '.form-radio', function () { 
              $('select[data-drupal-selector="edit-tid-sel"]').val($(this).val());
            });              
          }
        });
      }
    }
    
    

})(jQuery, window, Drupal, once);